import React, { useEffect } from 'react';
import { Modal, Button, Tag, Divider, Typography, Spin } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { Ticket } from '../../api/TicketApi';
import dayjs from 'dayjs';
import { TicketChat } from './TicketChat';
import { message } from 'antd';
import { useStore } from '../../stores/root-store-context';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

interface TicketDetailsModalProps {
    visible: boolean;
    ticket: Ticket | null;
    onClose: () => void;
    onCloseTicket: (ticketId: string) => void;
    mode: 'customer' | 'support';
}

export const TicketDetails: React.FC<TicketDetailsModalProps> = ({
    visible,
    ticket,
    onClose,
    onCloseTicket,
    mode
}) => {

    const { ticketStore, ticketChatStore, applicationStore } = useStore();
    const { t } = useTranslation();

    useEffect(() => {
       if(visible){
        ticketChatStore.messages = ticketStore.currentTicket?.messages || [];

        // ticketStore.getTicketsById(ticket?.id || "").then((ticket) => {

        // })
       }
    }, [ticketStore.currentTicket?.messages, visible]);

    if (!ticket) return null;

    const renderTag = (value: number, type: 'priority' | 'status') => {
        let color = '';
        switch (value) {
            case 1:
                color = 'red';
                break;
            case 2:
                color = 'orange';
                break;
            case 3:
                color = 'green';
                break;
        }
        return <Tag color={color}>{type.toUpperCase()}: {value}</Tag>;
    };

    return (
        <Modal
            title={''}
            visible={visible}
            onCancel={onClose}
            footer={[
            ]}
            width={900}
        >
            <Title style={{wordBreak: 'break-word', whiteSpace: 'pre-wrap', maxWidth:'550px'}} level={5}>{ticket.subject}</Title>
            <Text type="secondary">{t("Created")}: {dayjs(ticket.createdAt).format('DD MMM YYYY HH:mm')}</Text>
            <Divider />
            <Text><strong>{t("Email")}:</strong> {ticket.email}</Text><br />
            <Text><strong>{t("Language")}:</strong> {ticket.lang}</Text><br />
            <Text><strong>{t("Category")}:</strong> {ticket.category}</Text><br />
            <Text><strong>{t("Description")}:</strong></Text>
            <div style={{ marginTop: 8 }}>{ticket.description}</div>
            <Divider />
            {/* {renderTag(ticket.priority, 'priority')}
            {' '}
            {renderTag(ticket.status, 'status')} */}
            <Spin spinning={ticketStore.isLoading}>
                <TicketChat ticketId={ticket.id} mode={mode} />
            </Spin>
        </Modal>
    );
};
